import { Routes } from "@angular/router";
import { Arc42LeitfadenComponent } from "./components/albcode/techblog/techblog-detail/arc42-leitfaden/arc42-leitfaden.component";
import { Arc42Component } from "./components/albcode/techblog/techblog-detail/arc42/arc42.component";
import { AsciiDocComponent } from "./components/albcode/techblog/techblog-detail/ascii-doc/ascii-doc.component";
import { JUnitComponent } from "./components/albcode/techblog/techblog-detail/j-unit/j-unit.component";
import { JakartaComponent } from "./components/albcode/techblog/techblog-detail/jakarta/jakarta.component";
import { JavaCollectionsComponent } from "./components/albcode/techblog/techblog-detail/java-collections/java-collections.component";
import { LombokComponent } from "./components/albcode/techblog/techblog-detail/lombok/lombok.component";
import { RequirementsEngineeringComponent } from "./components/albcode/techblog/techblog-detail/requirements-engineering/requirements-engineering.component";
import { SpringComponent } from "./components/albcode/techblog/techblog-detail/spring/spring.component";
import { SwaggerComponent } from "./components/albcode/techblog/techblog-detail/swagger/swagger.component";
import { ToolBoxComponent } from "./components/albcode/techblog/techblog-detail/tool-box/tool-box.component";
import { UiuxDesignComponent } from "./components/albcode/techblog/techblog-detail/uiux-design/uiux-design.component";
import { TechblogHeaderComponent } from "./components/albcode/techblog/techblog-header/techblog-header.component";
import { TechblogComponent } from "./components/albcode/techblog/techblog.component";
import { SeoGuard } from "./guards/seo.guard";

export const techblogRoutes: Routes = [{
    path: 'techblog',
    component: TechblogHeaderComponent,
    data: {
        title: $localize`AlbCode - Unser Tech-Blog`,
        desc: $localize`Praxisnahe Artikel zu Java, Spring, Architektur und Tools: kompakte Leitfäden, Best Practices und direkt nutzbares Entwicklerwissen.`,
        keywords: [
            $localize`AlbCode Tech-Blog`,
            $localize`Java Tech-Blog`,
            $localize`ToolBox`,
            $localize`arc42`,
            $localize`Lombok`,
            $localize`Java Records`,
            $localize`Java Collections`,
            $localize`AsciiDoc`,
            $localize`AsciiFlow`,
            $localize`Spring Framework`,
            $localize`Spring Boot`,
            $localize`Jakarta Bean Validation Constraints`,
            $localize`JUnit`,
            $localize`Requirements Engineering`,
            $localize`UI/UX-Design`,
            $localize`Swagger`,
            $localize`Java`,
            $localize`Java Frameworks`,
            $localize`Java Best Practices`,
            $localize`Java Tutorials`,
            $localize`Programmierung`,
            $localize`Java Tools`,
            $localize`Java Technologien`,
            $localize`Java für Anfänger`,
            $localize`Fortgeschrittene Java-Themen`
        ]
    },
    children: [
        {
            path: 'list',
            component: TechblogComponent,
            canActivate: [SeoGuard]
        },
        {
            path: 'toolBox',
            component: ToolBoxComponent,
            data: {
                title: $localize`ToolBox von AlbCode: Sichere Datenverarbeitung und -validierung`,
                desc: $localize`Entdecken Sie die ToolBox von AlbCode - Ihre sichere Lösung für Datenverarbeitung und -validierung ohne Datenverlust.`,
                keywords: [
                    $localize`ToolBox`,
                    $localize`Datenverarbeitung`,
                    $localize`JSON-Validierung`,
                    $localize`Base64-Encoding`,
                    $localize`Datenschutz`,
                    $localize`IT-Sicherheit`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'arc42',
            component: Arc42Component,
            data: {
                title: $localize`Effektive Architekturdokumentation mit arc42`,
                desc: $localize`Erfahren Sie, wie Sie mit dem arc42 Template Ihre Softwarearchitektur effizient dokumentieren und optimieren können.`,
                keywords: [
                    $localize`arc42`,
                    $localize`Architekturdokumentation`,
                    $localize`Softwarearchitektur`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'lombok',
            component: LombokComponent,
            data: {
                title: $localize`Lombok vs. Records: Java-Vergleich`,
                desc: $localize`Ein detaillierter Vergleich von Lombok, Java Records und nativer Java-Implementierung.`,
                keywords: [
                    $localize`Lombok`,
                    $localize`Java Records`,
                    $localize`Java`,
                    $localize`Native Java-Implementierung`,
                    $localize`Java-Programmierung`,
                    $localize`Java-Entwicklung`,
                    $localize`Code-Optimierung in Java`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'javaCollections',
            component: JavaCollectionsComponent,
            data: {
                title: $localize`Java Collections effizient nutzen`,
                desc: $localize`Lernen Sie, Listen, Sets, Maps und Queues in Java zielgerichtet einzusetzen und typische Performance-Fallen zu vermeiden.`,
                keywords: [
                    $localize`Java`,
                    $localize`Java Collections`,
                    $localize`Queue`,
                    $localize`Programmierung`,
                    $localize`Softwareentwicklung`,
                    $localize`Java Entwickler`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'asciiDoc',
            component: AsciiDocComponent,
            data: {
                title: $localize`AsciiDoc und AsciiFlow im Einsatz`,
                desc: $localize`Erfahren Sie alles über AsciiDoc und AsciiFlow, von Grundlagen bis zu fortgeschrittenen Anwendungen in der textbasierten Dokumentation und Diagrammerstellung.`,
                keywords: [
                    $localize`AsciiDoc`,
                    $localize`AsciiFlow`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'spring',
            component: SpringComponent,
            data: {
                title: $localize`Spring Annotationen kompakt erklärt`,
                desc: $localize`Der Leitfaden erklärt wichtige Spring- und Spring-Boot-Annotationen praxisnah und zeigt, wann sie in Java-Projekten sinnvoll sind.`,
                keywords: [
                    $localize`Spring Framework`,
                    $localize`Spring Boot`,
                    $localize`Java Annotationen`,
                    $localize`Dependency Injection`,
                    $localize`MVC`,
                    $localize`Data Access`,
                    $localize`Spring Security`,
                    $localize`AOP`,
                    $localize`Java Entwicklung`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'jakarta',
            component: JakartaComponent,
            data: {
                title: $localize`Jakarta Bean Validation in Java`,
                desc: $localize`So verbessern Sie Datenqualität mit Jakarta Bean Validation: eingebaute und eigene Constraints, Best Practices und Integrationstipps.`,
                keywords: [
                    $localize`Jakarta Bean Validation`,
                    $localize`Datenvalidierung`,
                    $localize`Custom Constraints`,
                    $localize`JPA`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'jUnit',
            component: JUnitComponent,
            data: {
                title: $localize`Migration von JUnit 4 auf JUnit 5`,
                desc: $localize`Schritt-für-Schritt zur Migration von JUnit 4 auf JUnit 5 in Java- und Spring-Projekten - inklusive typischer Stolperfallen.`,
                keywords: [$localize`JUnit 5 Migration`,
                    $localize`JUnit 4 zu JUnit 5`,
                    $localize`Java Unit Testing`,
                    $localize`Spring Framework Tests`,
                    $localize`JUnit 5 Änderungen`,
                    $localize`JUnit Upgrade`,
                    $localize`JUnit 5 Annotations`,
                    $localize`Spring Boot JUnit 5`,
                    $localize`Java Testing Framework`,
                    $localize`Modernes Java Testing`]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'arc42Leitfaden',
            component: Arc42LeitfadenComponent,
            data: {
                title: $localize`arc42 Leitfaden für Softwarearchitektur`,
                desc: $localize`arc42 bietet eine klare Struktur für Architekturdokumentation mit Vorlagen, Best Practices und nachvollziehbarer Kommunikation im Team.`,
                keywords: [
                    $localize`arc42 Architekturframework`,
                    $localize`Softwarearchitektur mit arc42`,
                    $localize`arc42 Templates und Vorlagen`,
                    $localize`arc42 Dokumentation`,
                    $localize`Softwarearchitektur Best Practices`,
                    $localize`arc42 Zielszenarien`,
                    $localize`Softwarearchitektonische Sichtweisen`,
                    $localize`Architekturansicht mit arc42`,
                    $localize`Bausteinsicht und Komponenten`,
                    $localize`Laufzeitsicht in arc42`,
                    $localize`Verteilungssicht und Systemlandschaft`,
                    $localize`Nicht-funktionale Anforderungen in arc42`,
                    $localize`Entwurfsentscheidungen dokumentieren`,
                    $localize`Qualitätsziele und Qualitätsattribute`,
                    $localize`Risikobewertung und Technische Schulden in arc42`,
                    $localize`arc42 in der Praxis`,
                    $localize`arc42 Vorlagen für Architekturdokumentation`,
                    $localize`arc42 für Agile Projekte`,
                    $localize`arc42-Tools und -Software`,
                    $localize`Leitfaden zur Anwendung von arc42`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'requirementsEngineering',
            component: RequirementsEngineeringComponent,
            data: {
                title: $localize`Die Kunst des Requirements Engineering`,
                desc: $localize`Der Beitrag zeigt, wie Requirements Engineering mit Stakeholder-Analyse, Dokumentation und Validierung bessere Softwareprojekte ermöglicht.`,
                keywords: [
                    $localize`Requirements Engineering`,
                    $localize`Softwareentwicklung`,
                    $localize`Anforderungsmanagement`,
                    $localize`Stakeholder-Analyse`,
                    $localize`Projektmanagement`,
                    $localize`Softwarearchitektur`,
                    $localize`Qualitätssicherung in der Softwareentwicklung`,
                    $localize`Agiles Requirements Engineering`,
                    $localize`Anforderungsdokumentation`,
                    $localize`Anforderungsvalidierung`
                ]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'uiuxDesignComponent',
            component: UiuxDesignComponent,
            data: {
                title: $localize`Der Zauber von UI/UX Design`,
                desc: $localize`Warum gutes UI/UX Design entscheidend ist: klare Benutzerführung, bessere Usability und höhere Akzeptanz digitaler Produkte.`,
                keywords: [
                    $localize`UI/UX Design`,
                    $localize`Benutzeroberfläche`,
                    $localize`Benutzererfahrung`,
                    $localize`Designprinzipien`,
                    $localize`Webdesign`,
                    $localize`App-Design`,
                    $localize`Benutzerfreundlichkeit`,
                    $localize`UI-Design`,
                    $localize`UX-Design`,
                    $localize`Design Best Practices`]
            },
            canActivate: [SeoGuard]
        },
        {
            path: 'swagger',
            component: SwaggerComponent,
            data: {
                title: $localize`Swagger: Entwicklung und Dokumentation von REST APIs`,
                desc: $localize`Swagger unterstuetzt Sie beim API-Design, bei der Dokumentation und beim Testen von REST-Schnittstellen - praktisch und effizient.`,
                keywords: [
                    $localize`Swagger`,
                    $localize`OpenAPI Specification`,
                    $localize`RESTful API`,
                    $localize`API Dokumentation`,
                    $localize`API Design`,
                    $localize`API Entwicklung`,
                    $localize`Swagger UI`,
                    $localize`Swagger Editor`,
                    $localize`Swagger Codegen`,
                    $localize`API-Testing`,
                    $localize`API-Design`,
                    $localize`REST API`]
            },
            canActivate: [SeoGuard]
        }
    ],
    canActivate: [SeoGuard]
}];
